import axios from "axios";

const state = {
  weeks: null,
  weekInfo: {
    id: null,
  },
  weekGames: null,
  maxGameWeek: null,
};

const getters = {
  weeks(state) { return state.weeks },
  weekInfo(state) { return state.weekInfo },
  weekGames(state) { return state.weekGames },
  weekTotalPoints(state, getters) {
    if (!getters.weekGames) {
      return null;
    } else {
      let tot = 0;
      for (let x = 0; x < getters.weekGames.length; x++) {
        if (getters.weekGames[x].predictions && getters.weekGames[x].predictions.length) {
          tot += +getters.weekGames[x].predictions[0].result_points;
          tot += +getters.weekGames[x].predictions[0].score_points;
        } else {
          tot += 2;
        }
      }
      return tot;
    }
  },
  maxGameWeek(state) { return state.maxGameWeek },
};

const actions = {
  getCurrentWeek({ commit, dispatch }) {
    axios.get(process.env.VUE_APP_API_URL + 'week/current_week')
    .then(response => {
      commit('SET_WEEK_INFO', response.data.data.week);
      dispatch('getGames', response.data.data.week.id)
    })
  },
  getGames({ commit }, week_id) {
    axios.get(process.env.VUE_APP_API_URL + 'week/week_with_games/' + week_id)
    .then(response => {
      commit('SET_WEEK_GAMES', response.data.data.week.games);
    })
  },
  getWeeks({ commit }) {
    axios.get(process.env.VUE_APP_API_URL + 'week/get_season_weeks')
    .then(response => {
      commit('SET_WEEKS', response.data.data.weeks);
    })
  },
  getMaxGameWeek({ commit }) {
    axios.get(process.env.VUE_APP_API_URL + 'week/get_max_game_week')
    .then(response => {
      commit('SET_MAX_GAME_WEEK', response.data.data.max_game_week);
    })
  }
};

const mutations = {
  SET_WEEKS(state, data) {
    state.weeks = data;
  },
  SET_WEEK_INFO(state, data) {
    state.weekInfo = data;
  },
  SET_WEEK_GAMES(state, data) {
    state.weekGames = data;
  },
  SET_MAX_GAME_WEEK(state, weekId) {
    state.maxGameWeek = weekId
  }
};


export default {
  state,
  getters,
  actions,
  mutations,
}
